/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ReportsFindAllStatusItem } from './reportsFindAllStatusItem';
import type { ReportsFindAllAnimalTypeItem } from './reportsFindAllAnimalTypeItem';
import type { ReportsFindAllWildTypeItem } from './reportsFindAllWildTypeItem';
import type { ReportsFindAllSurveillanceTypeItem } from './reportsFindAllSurveillanceTypeItem';
import type { ReportsFindAllCategoryOfTestItem } from './reportsFindAllCategoryOfTestItem';

export type ReportsFindAllParams = {
  /**
   * Filter by report code (support incomplete search)
   */
  code?: string;
  /**
   * Filter by publication status
   */
  status?: ReportsFindAllStatusItem[];
  /**
   * Filter by animal type
   */
  animalType?: ReportsFindAllAnimalTypeItem[];
  /**
   * Filter by species
   */
  specie?: string;
  /**
   * Filter by wild type
   */
  wildType?: ReportsFindAllWildTypeItem[];
  /**
   * Filter by surveillance type
   */
  surveillanceType?: ReportsFindAllSurveillanceTypeItem[];
  /**
   * Filter by detection date (from) - ISO 8601 format
   */
  detectionDateFrom?: string;
  /**
   * Filter by detection date (to) - ISO 8601 format
   */
  detectionDateTo?: string;
  /**
   * Filter by order
   */
  order?: string;
  /**
   * Filter by user reports only
   */
  myReports?: boolean;
  /**
   * Filter by country code
   */
  countryCode?: string[];
  /**
   * Filter by region id
   */
  regionId?: string[];
  /**
   * Filter by known cause
   */
  knownCause?: boolean;
  /**
   * Filter by etiology type code
   */
  etiologyTypeCode?: string[];
  /**
   * Filter by etiological agent code
   */
  etiologicalAgentCode?: string[];
  /**
   * Filter reports that have at least one diagnostic procedure
   */
  hasDiagnosticProcedure?: boolean;
  /**
   * Filter reports that have diagnostic procedures with specific category of test
   */
  categoryOfTest?: ReportsFindAllCategoryOfTestItem[];
  /**
   * Filter reports that have diagnostic procedures with specific sample type code
   */
  sampleTypeCode?: string[];
  /**
   * Page number for pagination
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort criteria array with format: [{"id": "countryCode", "order": "asc"}]
   */
  sortBy?: string;
};
